import { createContext } from 'react';
import { buildUseContextHook } from './helpers/utilities';
const Context = createContext(null);
export const ContextProvider = Context.Provider;
export const useCodenameChangedHandler = buildAdapterHook('useCodenameChangedHandler', 'onCodenameChange');
export const useOnModuleEnded = buildAdapterHook('useOnModuleEnded', 'onModuleEnded');
export const useVideoComponent = buildAdapterHook('useVideoComponent', 'videoComponent');
export const useActionTrigger = buildAdapterHook('useActionTrigger', 'onActionTrigger');
export const useErrorNotify = buildAdapterHook('useErrorNotify', 'onErrorNotify');
export const useOnMomentRender = buildAdapterHook('useOnMomentRender', 'onMomentRender');
/**
 * Convinence function that ensures devs use the hook within the Provider, and pulls out the given
 * adapter from the Context object.
 */
function buildAdapterHook(hookName, context) {
    const useHook = buildUseContextHook(Context, hookName, 'ContextProvider');
    return () => useHook()[context];
}
//# sourceMappingURL=adapters.js.map